import request from '@/utils/request';

let bannerApi = {
    // 轮播图列表
    getBannnerList(data, err) {
        return request._get('/shop/banner/banner/pcList', data, err);
    },
    // 新增轮播图
    getAddBanner(data, err) {
        return request._postBody('/shop/banner/banner/addBanner', data, err);
    },
    // 编辑轮播图
    getUpdateBanner(data, err) {
        return request._postBody('/shop/banner/banner/updateBanner', data, err);
    },
    // 删除轮播图
    getDelBanner(data, err) {
        return request._get('/shop/banner/banner/delBanner', data, err);
    },
}

export default bannerApi;



// WEBPACK FOOTER //
// ./src/api/setting/banner.js